import http from "./http"
const editor = {
  //可操作的科目列表
  mySubjectList() {
    return http.post("editor/article/mySubject", {})
  },

  //稿件池
  articleListGJC(f_subjectId, f_title, order, sort, page, size) {
    return http.post("editor/article/article_unaudited?f_subjectId=" + f_subjectId + "&f_title=" + f_title + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //待评审稿件
  articleListAudit(f_subjectId, f_title, order, sort, page, size) {
    return http.post("editor/article/article_audit?f_subjectId=" + f_subjectId + "&type=1&f_title=" + f_title + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //已评审稿件
  articleListAudited(f_subjectId, f_title, order, sort, page, size) {
    return http.post("editor/article/article_audit?f_subjectId=" + f_subjectId + "&type=2&f_title=" + f_title + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //批量锁定稿件，加入购物车
  addArticlesToCart(articleIds) {
    return http.post("editor/article/locks?typeId=1", { articleIds: articleIds })
  },

  //批量取消锁定稿件，移出购物车
  removeArticlesFromCart(articleIds) {
    return http.post("editor/article/locks?typeId=2", { articleIds: articleIds })
  },

  //锁定稿件，加入购物车
  addArticleToCart(articleId) {
    return http.post("editor/article/lock?typeId=1&articleId=" + articleId, {})
  },

  //取消锁定稿件，移出购物车
  removeArticleFromCart(articleId) {
    return http.post("editor/article/lock?typeId=2&articleId=" + articleId, {})
  },

  //获取稿件运行流程
  getArticleProcessList(articleId) {
    return http.get("editor/article/processList?articleId=" + articleId)
  },

  //审稿
  doAudit(articleId, opinion, remark, attachId) {
    let modal = {
      articleId: articleId,
      opinion: opinion,
      remark: remark,
      attachId: attachId,
    }
    return http.post("editor/audit/edit", modal)
  },

  //待登记/已登记版面费稿件
  getChargeList(f_subjectId, f_title, type, order, sort, page, size) {
    return http.post("editor/article/page_costed?f_subjectId=" + f_subjectId + "&f_title=" + f_title + "&type=" + type + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //登记版面费
  doCharge(articleIds, amounts, letterNoticePage, letterNoticeTime) {
    let modal = {
      articleIds: articleIds,
      amounts: amounts,
      letterNoticePage: letterNoticePage,
      letterNoticeTime: letterNoticeTime,
    }
    return http.post("editor/article/page_cost", modal)
  },

  //版面费缴纳情况稿件
  getBmfList(f_subjectId, f_title, type, order, sort, page, size) {
    return http.post("editor/article/layout_costed?f_subjectId=" + f_subjectId + "&f_title=" + f_title + "&type=" + type + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //编辑拒绝撤稿
  rejectArticle(articleId, type) {
    return http.post("editor/Article/ArticleReject?articleId=" + articleId + "&type=" + type)
  },
}
export default editor
